import React from 'react';

import { DashboardContentLayout, LocationTabs } from '@portals/framework';
import { TabType } from '@portals/types';

import { InvoicesTable } from './InvoicesTable';

export function Invoices() {
  const TABS: Array<TabType> = [
    {
      id: 'all',
      name: 'all',
      title: 'All',
      Component: () => <InvoicesTable status="all" />,
    },
    {
      id: 'pending',
      name: 'pending',
      title: 'Pending',
      Component: () => (
        <InvoicesTable
          status="pending"
          subtitle="Invoices that needs to be paid"
        />
      ),
    },
    {
      id: 'paid',
      name: 'paid',
      title: 'Paid',
      Component: () => <InvoicesTable status="paid" subtitle="Paid invoices" />,
    },
    {
      id: 'failed',
      name: 'failed',
      title: 'Payment failed',
      Component: () => (
        <InvoicesTable
          status="failed"
          subtitle="Payment for these invoices failed, need to sort out payment before expiry"
        />
      ),
    },
    {
      id: 'expired',
      name: 'expired',
      title: 'Expired',
      Component: () => (
        <InvoicesTable
          status="expired"
          subtitle="Payment for these invoices was not completed successfully and they are no longer valid"
        />
      ),
    },
  ];

  return (
    <DashboardContentLayout
      pageTitle="Invoices"
      breadcrumbs={[
        { label: 'Store Management', to: '/store-management' },
        { label: 'Invoices' },
      ]}
      bg="gray.0"
    >
      <LocationTabs tabs={TABS} />
    </DashboardContentLayout>
  );
}
